export default {
  route: {
    home: '首页',
    aboutus: '关于我们',
    rank: '驾值榜',
    ev: 'EV大数据应用',
    salvageValue: '残值预测与租赁',
    secondHand: '二手车估值与金融'
  },
  home: {
    title1: '新能源汽车大数据研究与应用',
    title2: '科技、数据融合 深度挖掘价值',
    title3: '人 车 服务・模式 创新 体验',
    introduce1: '融合数据、算法、模型深入研究新能源汽车全生命周期价值',
    introduce2: '基于业务场景数据进行分析，为汽车金融行业提供数据服务',
    introduce3: '以提升消费者购车体验为目标，为汽车行业提供数据创新服务',
    ev: 'EV大数据应用',
    evContent: '整合汽车行业大数据、用户用车行为、车企汽车数据，融合算法、模型对新能源汽车的使用及全生命周期价值做深入研究，助力新能源汽车行业的发展。 ',
    salvageValue: '残值预测与租赁',
    salvageValueContent: '基于汽车交易数据、汽车运行数据、用车行为数据等，结合算法、人工智能技术建立了全面、可靠、及时的残值预测模型体系，致力于管理并提升汽车品牌价值。',
    secondHand: '二手车估值与金融',
    secondHandContent: '整合二手车行业线上线下数据，以模型、算法为基础，构建精准的估值引擎系统，为二手车市场流通各环节提供估值定价服务，提升客户对二手车的认可度，增加二手车商家的风控能力。 ',
    youshi: '优势与创新',
    youshititle1: '汽车行业大数据',
    youshifont1_1: '多渠道、多维度、高质量、精细化',
    youshifont1_2: '数据融合，场景化运营管理',
    youshifont1_3: '晶钻分析，深度挖掘',
    youshititle2: '电池健康管理',
    youshititle2_1: '电池健康监测',
    youshititle2_2: '电池寿命预测',
    youshititle2_3: '电池安全预警',
    youshititle3: '数据算法和模型',
    youshititle3_1: '行业领先的数据挖掘技术',
    youshititle3_2: '行业特有的模型和算法矩阵',
    youshititle3_3: '先进的人工智能应用技术',
    youshititle4: '智能云平台',
    youshititle4_1: '人工智能学习',
    youshititle4_2: '云数据服务',
    youshititle4_3: '分布式即时服务'
  },
  aboutus: {
    name: '关于我们',
    introduce1:
      '一场蓄势待发的数字化变革即将在汽车行业到来，新能源汽车的发展为智能化技术提供了最佳载体，而智能化技术的发展又为用户提供了全新用车体验。未来的汽车将不仅仅是交通工具，汽车将成为人们的“移动生活空间”。',
    introduce2: '上海优与汽车科技有限公司创立于2015年，为国家级高新技术企业，上海市现代服务业试点企业，深耕新能源汽车生命周期价值管理的多个业务场景，融合机器学习与智能决策模型为新能源汽车行业提供前瞻性的业务解决方案。',
    introduce21: '2019年，优与科技深耕新能源汽车行业，搭建了全国首个融合了新能源车动力电池健康度衰减模型的整车与电池残值预测模型。',
    introduce22: '2020年，优与科技利用强大的数据库支撑，自主研发并搭建出全国首个结合新能源车企残值管理策略的自营二手车定价系模型与系统。',
    introduce23: '2022年初，优与科技与罗兰贝格发布《2021年中国新能源汽车保值率排行榜》。',
    advantageTitle: '优势与核心技术',
    advantageText: '优与科技是国内第一家垂直于新能源汽车全生命周期管理的高新技术企业，搭建了全国首个融合了新能源车动力电池衰减模型的整车与电池残值预测模型。',
    advantageTitle1: '行业咨询及市场调研',
    advantageText1: '为主机厂提供市场策略分析、及调研服务，包括汽车行业的各类创新业务模式与技术发展路径研究。',
    advantageTitle2: '残值预测及管理、定价模型与系统开发',
    advantageText2: '基于动态残值预测模型，为主机厂提供新能源车的残值预测，现值监控，残值管理方案，以及基于残值的各类金融产品的设计。',
    advantageTitle3: '新能源二手车数字化业务平台解决方案',
    advantageText3: '适用于车企与集团经销商自营二手车业务的全流程数字化二手车业务系统，包括智能防错知识库检测评估系统、智能定价与整备管理系统。优与科技致力于为车企提供完整的新能源二手车业务数智化全流程管理解决方案，助力新能源二手车业务发展与残值管理。',
    productsServices: '产品与服务',
    products: '产品：',
    products1: '新能源整车与电池残值预测模型',
    products2: '新能源二手车残值管理与定价策略模型及系统',
    products2Text: '基于新能源汽车多维度数据，结合人工智能大数据算法，搭建的新能源汽车残值预测模型体系，服务于新能源汽车金融与二手车交易。',
    services: '服务：',
    services1: 'EV大数据应用',
    services1Text: '整合汽车行业大数据、用户用车行为、车企汽车数据，融合算法、模型对新能源汽车的使用及全生命周期价值做深入研究，助力车企数字化转型，推动新能源汽车行业的发展。',
    
    introduce3: '优与科技通过数据平台和算法模型对海量数据进行整合管理、互联互通、智能决策，挖掘汽车行业数据价值，帮助企业在产品规划，新车销售、二手车再营销与残值管理等领域实现利润最大化。',
    declarationName: '服务理念',
    declaration: '"我们为用户提供专业、可靠的数据服务，通过深入场景的价值挖掘，帮助用户发展、提升品牌价值，依靠数据、创新、科技逐步走向成功。"',
    declaration_title1: '寻找商机',
    declaration_title2: '价值服务',
    declaration_title3: '数据、科技、创新',
    // declaration_content1: '在变化的市场和高速技术变革中，人们很难预测发展——变革不再循序渐进，速度大幅提高。快速应对市场变化、帮助客户快速突破瓶颈、整合数据的力量驱动发展。',
    declaration_content1: '帮助客户快速突破瓶颈、整合数据的力量驱动发展。',
    // declaration_content2: '依托新能源汽车大数据，围绕用户用车习惯、特征，为用户提供增值服务，同时通过多维度数据分析，提升用户用车体验。',
    declaration_content2: '依托新能源汽车大数据，围绕用户用车习惯、特征，为企业提供增值服务。',
    // declaration_content3: '在数字化时代，紧跟科技发展脚步，围绕用户痛点、需求进行业务创新，助力新能源汽车行业发展，做新能源汽车大数据应用领先者。',
    declaration_content3: '在数字化时代，紧跟科技发展脚步，进行业务创新，助力新能源汽车行业发展，做新能源汽车大数据应用领先者。',
    hornerName: '发展历程和荣誉',
    // 201908: '上海高新技术企业奖',
    // 201905: '上海市科技型中小企业奖',
    // 201811: '与蔚来汽车建立新能源汽车残值系统合作',
    // 201809: '获得上海市现代服务业重点单位称号',
    // 201805: '建立新能源汽车残值研究方法论，并与工信部大数据平台展开合作',
    // 2018052: '上海市科技型中小企业技术创新资金',
    // 201804: '上海市科技型中小企业奖',
    // 201802: '大众汽车建立评估检测合作',
    // 201708: '完成B轮7000万融资云集资本领投',
    // 2017051: '上海市科技型中小企业技术创新优秀企业奖',
    // 2017052: '上海市科技型中小企业技术创新资金',
    // 201703: '建立伯乐专家估值团队，一车一况一价定价',
    // 201605: '与滴滴出行建立检测战略合作',
    // 201512: '完成A轮3200万人民币投资，松禾资本领投',
    // 201506: '业务上线为C端提供检测服务',
    // 201505: '种子轮融资',

    202105: '与一汽奥迪建立合作， 为其提供新能源二手车残值管理咨询与系统解决方案',//
    202003: '与罗兰贝格强强联手，发布《2019中国新能源汽车“驾值榜”》',//
    201908: '上海高新技术企业奖',
    201905: '上海市科技型中小企业奖',
    201811: '与蔚来汽车建立合作，助力蔚来汽车二手车业务发展',//
    201809: '获得上海市现代服务业重点单位称号',
    201805: '建立新能源汽车残值研究方法论，并与工信部大数据平台展开合作',
    2018052: '上海市科技型中小企业技术创新资金',
    201804: '上海市科技型中小企业奖',
    201802: '与大众中国建立合作，提供二手车置换/回购与二手车处置服务',//
    201708: '获得B轮融资，投资方为云集资本、松禾资本',//
    2017051: '上海市科技型中小企业技术创新优秀企业奖',
    2017052: '上海市科技型中小企业技术创新资金',
    201703: '建立伯乐专家估值团队，一车一况一价定价',
    201605: '与滴滴出行建立检测战略合作',
    201512: '获得 A轮融资，由松禾资本领投，以及包括镭厉资本在内的上一轮投资机构跟投',//
    201506: '业务上线为C端提供检测服务',
    201505: '种子轮融资',
    // 201501: '获得 A轮融资，由松禾资本领投，以及包括镭厉资本在内的上一轮投资机构跟投',//

    horner1: '种子轮融资',
    horner2: '业务上线为C端提供检测服务',
    horner3: '完成A轮3200万人民币投资，松禾资本领投',
    horner4: '与滴滴出行建立检测战略合作',
    horner5: '建立伯乐专家估值团队，一车一况一价定价',
    horner6: '上海市科技型中小企业技术创新优秀企业奖',
    horner7: '完成B轮7000万融资云集资本领投',
    horner8: '大众汽车建立评估检测合作',
    horner9: '建立新能源汽车残值研究方法论，并与工信部大数据平台展开合作',
    horner10: '获得上海市现代服务业重点单位称号名单',
    horner11: '与蔚来汽车建立新能源汽车残值系统合作'
  },
  rank: {
    headerTitle1: '新能源汽车全生命周期价值管理挑战与展望',
    headerTitle2: '暨《2019中国新能源汽车“驾值榜”发布》',
    headerTitle: '新能源汽车全生命周期价值管理挑战与展望  暨《2019中国新能源汽车“驾值榜”发布》',
    subTitle: '2020年3月20日的最新动态',
    content_title1: '特斯拉Model X和Model 3在新能源纯电动汽车SUV和轿车榜单中位居第一，特斯拉、蔚来、比亚迪3大新能源汽车品牌表现抢眼',
    content_title2: '“保值率”研究助力新能源车产品价值提升',
    content_title3: '通过研究发现：',
    content_title4: '综上，我们发布了2019年纯电动汽车保值率排名，即《驾值榜》。',
    detail: '根据以上榜单，对排名前五的车系进行具体分析',
    imageTitle1: '1. 2019年纯电动SUV保值率排行',
    imageTitle2: '2. 2019年纯电动轿车保值率排行',
    content_title5: '尾言：',
    share: '分享此页：'
  },
  // rank: {
  //   headerTitle1: '新能源汽车全生命周期价值管理挑战与展望',
  //   headerTitle2: '暨《2019中国新能源汽车“驾值榜”发布》',
  //   headerTitle: '新能源汽车全生命周期价值管理挑战与展望  暨《2019中国新能源汽车“驾值榜”发布》',
  //   subTitle: '2020年3月20日的最新动态',
  //   content_title1: '特斯拉Model X和Model 3在新能源纯电动汽车SUV和轿车榜单中位居第一，特斯拉、蔚来、比亚迪3大新能源汽车品牌表现抢眼',
  //   content1: '由优与科技和罗兰贝格共同发布的“驾值榜”是针对2019年中国新能源汽车市场中的纯电动车型，基于其市场挂牌数据和实际交易数据的大数据模型评估数据，经过本地化调研验证和深入研究后得出一年保值率。',
  //   content2: '此榜单后续会定期进行发布，此次榜单只针对纯电动汽车车型的SUV和轿车进行保值率分析。',
  //   content3: '对于社会突发事件（如本次新冠肺炎疫情）等对车辆保值率的影响暂未涉及与考虑，后期会逐步增加对这些因素的综合考虑。',
  //   content_title2: '2019年新能源纯电动汽车研究发现：',
  //   content4: '新能源汽车保值率整体偏低，主要是因为：电池技术的快速进步，使得车辆整体性能较前期产品有较大的提升；缺乏统一的新能源汽车检测评估标准，特别是对于动力电池的检测评估，阻碍了二手车的流通；新能源二手车交易量有限，暂未形成稳定的供需关系，导致成交价与车辆实际价值之间形成较大的偏离。',
  //   content5: '保值率在50%及以上的车型在整体新能源汽车市场上处于一个相对领先的水平，其中部分主机厂在新车营销及二手车再营销层面早早布局，通过发布认证二手车项目、保值回购服务以及提供免费加电、免费保养等增值服务，以三位一体的整体战略逐步消除消费者对新能源汽车的电池与残值忧虑，不断提升消费者的用车体验，对其保值率处于较高的位置提供了有利的保障。 ',
  //   content6: '纯电动SUV保值率排名较为明显分为两个阶梯，豪华品牌纯电动SUV处于第一阶梯，自主品牌主流车型居于第二阶梯。第一阶梯与第二阶梯车型都具有较高的产品力，但在残值管理及再营销策略的运用上存在明显区别，最终导致其保值率出现较大差异。',
  //   content7: '纯电动轿车保值率排名中出现一线合资品牌车型反而处于保值率的中间水平，主要原因在于其推出的新能源产品大部分处于过渡阶段，其新能源战略产品尚未推出，残值管理以及再营销策略还未全面推向市场。',
  //   content_title3: '“保值率”研究助力新能源车产品价值提升',
  //   content8: '随着新能源汽车市场的不断成熟，消费者期待更好的用车体验，新能源车产品价值提升是车企面临的重大挑战。汽车保值率是衡量车辆价值衰减趋势的重要指标，保值率的研究帮助车企识别品牌产品价值、市场位置。',
  //   content9: '保值率在汽车全生命周期管理中的作用举足轻重，车企通过对保值率的追踪，真实、准确的了解自身品牌量化保值水平，发现差距，识别行业领先竞品和优秀实践。 ',
  //   content10: '在市场管理和运营中通过产品、商业模式等综合手段，衡量和监控品牌和产品价值提升水平，最终提升品牌与产品价值，为新能源汽车健康、可持续发展提供强劲动力。',
  //   detail: '根据以上榜单，对排名前五的车系进行具体分析, 点击',
  //   detail_btn: '查看详情',
  //   download: '新能源汽车全生命周期产业发展挑战与展望.pdf 下载(2.3MB)',
  //   detailTitle_suv: '2019年中国纯电动SUV保值率排行榜TOP5',
  //   detailTitle: '2019年中国纯电动轿车保值率排行榜TOP5'
  // },
  salvageValue: {
    name: '残值预测与租赁',
    introduce1: '',
    introduce2: '基于汽车交易数据、汽车运行数据、用车行为数据等，结合算法、人工智能技术建立了全面、可靠、及时的残值预测模型体系，致力于管理并提升汽车品牌价值。',
    subTitle1: '残值与汽车生命周期',
    subTitle2: '控制风险 专注价值',
    subTitle3: '残值预测模型',
    subTitle4: '合作案例'
  },
  footer: {
    aboutus: '关于我们',
    aboutus_content1: '公司简介',
    aboutus_content2: '服务宣言',
    aboutus_content3: '发展历程',
    business: '业务介绍',
    business_content1: 'EV大数据应用',
    business_content2: '残值预测与租赁',
    business_content3: '二手车估值与金融',
    cooperation: '商务合作',
    cooperation_content1: '申请试用',
    cooperation_content2: '专项合作',
    contact: '联系我们',
    contact_address: '上海市徐汇区南宁路970号李锦记大厦901A',
    contact_phone: '021-64666165',
    contact_email: 'limingming@autobole.com'
  },
  cooperation: {
    title1: '优与科技',
    title2: '期待与您合作共赢',
    formtTitle: '专项合作',
    company: '企业名称',
    phone: '联系电话',
    time: '希望合作时间',
    rule_company: '请输入企业名称',
    rule_phone: '请输入联系电话',
    rule_time: '请输入合作时间',
    button: '提交合作申请',
    tipe: '有合作意向也可以发邮件至limingming@autobole.com，我们会尽快给您回复'
  },
  applyFor: {
    title1: '优与科技',
    title2: '期待与您合作共赢',
    formtTitle: '申请试用',
    company: '企业名称',
    phone: '联系电话',
    email: '企业邮箱',
    rule_company: '请输入企业名称',
    rule_phone: '请输入联系电话',
    rule_email: '请输入企业邮箱',
    button: '提交试用申请',
    tipe: '有合作意向也可以发邮件至limingming@autobole.com，我们会尽快给您回复'
  },
  ev: {
    name: 'EV大数据应用',
    nav_content: '整合汽车行业大数据、用户用车行为、车企汽车数据，融合算法、模型对新能源汽车的使用及全生命周期价值做深入研究，助力新能源汽车行业的发展。',
    subTitle1: '助力车企数字化转型',
    subTitle2: '基于新能源汽车检测评估及电池健康度的评估服务',
    subTitle3: '新能源汽车租赁与回购解决方案',
    part1_box1_title: '场景价值',
    part1_box1_subtitle: '实现各方数据打通、挖掘落地场景是变现的必要条件',
    part1_box1_content: '为汽车厂商数据打通解决方案，融合用户、车辆、企业数据、第三方数据，实现各方数据的深度打通、整合与分析，挖掘更多创造价值的应用场景。',
    part1_box2_title: '用户数据',
    part1_box2_subtitle: '是精准内容分发、个性化服务推荐、互动体验的基础',
    part1_box2_content: '包括驾驶行为数据、驾乘操作数据、车载应用数据、全渠道交互数据等',
    part1_box3_title: '企业数据',
    part1_box3_subtitle: '是优化运营决策、提升协同效率的重要前提',
    part1_box3_content: '生成制造和供应链数据，特别是上下游合作伙伴系统基础数据，以及产品与服务的经验数据等',
    part1_box4_title: '车辆数据',
    part1_box4_subtitle: '是技术创新迭代、产品研发的重要基础',
    part1_box4_content: '包括汽车行车工况、车辆监控、车主系统、车辆诊断、地图导航及周围场景数据等',
    part2_subtitle: '新能源二手车无标准化的检测评估方法',
    part2_content1:
      '当前市场没有新能源二手车的检测评估方案，买家对于车况的担忧无法解决，严重制约新能源二手车市场的发展和渠道流通；新能源汽车与传统燃油车最大的区别就是三电系统，需要建立针对新能源汽车三电系统的标准化检测与评估方法。',
    part2_content2: '新能源二手车认证体系对新能源汽车残值管理有重要的意义，基于燃油车检测标准，建立以电池健康度认证为基础的新能源二手车认证体系刻不容缓。',
    part3_subtitle: '租赁解决方案、风险管控与方案优化',
    part3_content1: '优与科技根据电池寿命与健康度模型为新能源汽车车企、租赁与运营车辆用户提供售后延保产品与方案优化'
  },
  secondHand: {
    name: '二手车估值与金融',
    nav_content: '整合二手车行业线上线下数据，以模型、算法为基础，构建精准的估值引擎系统，为二手车市场流通各环节提供估值定价服务，提升客户对二手车的认可度，增加二手车商家的风控能力。',
    subTitle1: '估值引擎系统',
    subTitle2: '应用场景',
    part2_box1_title: '置换',
    part2_box2_title: '保险',
    part2_box3_title: '共享',
    part2_box1_content1: '车主、专业评估师做车辆',
    part2_box1_content2: '价值预估和定价',
    part2_box1_content3: '渠道根据定价进行销售',
    part2_box1_content4: '车商控制风险',
    part2_box1_content5: '厂商做品牌价值参考',
    part2_box2_content1: '汽车保险',
    part2_box2_content2: '金融公司控制风险',
    part2_box2_content3: '保险公司产品设计',
    part2_box3_content1: '共享汽车量化分布',
    part2_box3_content2: '汽车价值和盈利平衡',
    part2_box3_content3: '车辆使用成本',
    part2_box3_content4: '用户使用习惯对车的影响'
  }
}
